import axios from 'axios';
import { EventBus } from '../event/event-bus.js';
import router from '.././router';

const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            if (method === "put" || method === "delete") {
                EventBus.$emit('emit-success');
            }
            return req.data
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 403) {
                    router.push({ name: 'Unauthorized' });
                    return;
                } else if (error.response.status === 401) {
                    location.reload();
                    return;
                }
            }
            EventBus.$emit('emit-error', error.response.data);
        })
    },
    //Users
    async searchUsers(accessToken, searchText, pageNo, pageSize, orderBy, sorting) {
        return await this.execute('get', `/user/search?pageNo=${pageNo}&pageSize=${pageSize}&searchText=${searchText}&orderBy=${orderBy}&sorting=${sorting}`, null, accessToken);
    },
    async registerUser(accessToken) {
        return await this.execute('post', `/user/register`, null, accessToken);
    },
    async updateUser(request, accessToken) {
        return await this.execute('put', `/user`, request, accessToken);
    }
}
